module.exports = __webpack_public_path__ + "static/media/shila_thumb.e02091ad.jpg";